// extracted by mini-css-extract-plugin
export var telephoneNumber = "SideMenu-module--telephoneNumber--2jdhc";
export var email = "SideMenu-module--email--HAc2M";
export var top = "SideMenu-module--top--2tyDX";
export var menuItems = "SideMenu-module--menuItems--1Vg8I";
export var wrapper = "SideMenu-module--wrapper--3-CzJ";
export var open = "SideMenu-module--open--2fdfb";
export var inner = "SideMenu-module--inner--mww3H";
export var bottom = "SideMenu-module--bottom--18qlL";